import { render, staticRenderFns } from "./editorSettingsDialog.vue?vue&type=template&id=5cbc5e15&"
import script from "./editorSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./editorSettingsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports